var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwCreators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.625 174.406C318.112 259.713 243.395 324.129 157.798 324.129H10.3966C6.33434 324.129 3.14258 320.937 3.14258 316.875C3.14258 294.677 3.14258 225.909 3.14258 169.183C3.14258 83.7309 67.5582 9.01456 152.865 3.35643C249.924 -3.0271 330.153 77.2023 323.77 174.261L323.625 174.406Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.174 168.894C302.16 247.382 238.47 311.072 159.982 200.086C81.4931 311.072 17.8029 247.382 128.789 168.894C17.8029 90.4052 81.4931 26.715 159.982 137.701C238.47 26.715 302.16 90.4052 191.174 168.894Z",
    fill: "#9B5DE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M316.663 3.06738H10.254C6.24773 3.06738 3 6.31511 3 10.3214V316.731C3 320.737 6.24773 323.985 10.254 323.985H316.663C320.67 323.985 323.917 320.737 323.917 316.731V10.3214C323.917 6.31511 320.67 3.06738 316.663 3.06738Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwCreators);
export default __webpack_public_path__ + "static/media/dfw-Creators.0eae4b57d963b18085ae6a0e3954514d.svg";
export { ForwardRef as ReactComponent };